'use strict';

module.exports = function initLoginTabsKeyboard() {
    var $ = window.$;
    if (!$) {
        return;
    }

    $(document).ready(function () {
        var $tablist = $('.login-page [role="tablist"]');
        if (!$tablist.length) {
            return;
        }

        $tablist.on('shown.bs.tab', '[role="tab"]', function () {
            var $tabs = $tablist.find('[role="tab"]');
            $tabs.attr({ tabindex: '-1', 'aria-selected': 'false' });
            $(this).attr({ tabindex: '0', 'aria-selected': 'true' });
        });

        $tablist.on('keydown', '[role="tab"]', function (e) {
            var $tabs = $tablist.find('[role="tab"]');
            var idx = $tabs.index(this);
            var newIdx;

            switch (e.key) {
                case 'ArrowRight':
                case 'ArrowDown':
                    newIdx = (idx + 1) % $tabs.length;
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    newIdx = (idx - 1 + $tabs.length) % $tabs.length;
                    break;
                case 'Home':
                    newIdx = 0;
                    break;
                case 'End':
                    newIdx = $tabs.length - 1;
                    break;
                default:
                    return;
            }

            e.preventDefault();
            var $newTab = $tabs.eq(newIdx);
            $newTab.attr('tabindex', '0').trigger('focus');
            $newTab.tab('show');
        });
    });
};
